import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootAccountComponent } from './root-account/root-account.component';
import { MyWeaponsComponent } from './my-weapons/my-weapons.component';
import {NewWeaponComponent} from "./new-weapon/new-weapon.component";
import {UpdateWeaponComponent} from "./update-weapon/update-weapon.component";
import {MyRequestsComponent} from "./my-requests/my-requests.component";
import {NewRequestComponent} from "./new-request/new-request.component";

const routes: Routes = [
  {
    path: '',
    component: RootAccountComponent,
    children: [
      {
        path: '',
        redirectTo: 'my-weapons',
        pathMatch: 'full',
      },
      { path: 'my-weapons', component: MyWeaponsComponent },
      { path: 'new-weapon', component: NewWeaponComponent },
      { path: 'update-weapon/:id', component: UpdateWeaponComponent },
      { path: 'my-requests', component: MyRequestsComponent },
      { path: 'new-requests', component: NewRequestComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WeaponsRoutingModule {}
